module.exports = __webpack_public_path__ + "img/IMG_1581.2f0ded94.jpeg";